import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ReactGA from 'react-ga'
import { clearStory, selectChunkedStories, refreshFullPageAd } from './store/storiesReducer'
import HeaderBar from './HeaderBar'
import NonFeaturedStoriesList from './NonFeaturedStoriesList'
import FullPageAd from './FullPageAd'
import { CarouselWrapper } from './CarouselWrapper'
import { getIndex } from './PageHelper'
import { makeStyles } from '@material-ui/core'
import FeaturedStoryFactory from './FeaturedStoryFactory'

function isAtBottom(index, slidesNo){
  return index === slidesNo
}

function isAtTop(index){
  return index === 0
}

const useStyles = makeStyles({
  slideRoot: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 70,
    height: window.innerHeight
  }
})


function GameDay() {
  const dispatch = useDispatch()
  const classes = useStyles()

  const [slideIndex, setSlideIndex] = useState(0)
  const stories = useSelector(selectChunkedStories)
  const [loadedSlided, setLoadedSlided] = useState([])


  useEffect(() => {
    dispatch(clearStory())
  }, [dispatch])

  useEffect(() => {
    if(!stories || stories.length === 0) return

    //after stories load, set current slide
    const index = getIndex(sessionStorage, stories)
    setSlideIndex(index)
    const story = stories[index][0]
    lazyLoadSlides(index)

    //prevent tracking a slide view when we're going to a previous slide
    if(index === 0) {
      TrackSlideView(story, index)
    }
  }, [dispatch, stories])

  const lazyLoadSlides = function (idx) {
    const newLoadedSlided = new Array(slides.length)
    newLoadedSlided.fill(false)
    for(let i = 0; i < slides.length; i++) {
      newLoadedSlided[i] = i <= idx+2
    }
    setLoadedSlided(newLoadedSlided)
  }

  // how to tell different stories?
  let flip = false

  const slides = stories.map((row, index) => {
    const key = row.map(s => s._id).join('-')

    flip = !flip

    // if flip is true, then 3 story page layout
    // if flip is false, then full page ad

    if(flip) {
      const [story, ...rest] = row

      return (
        <div className={classes.slideRoot} key={key}>
        <FeaturedStoryFactory story={story} />
        <NonFeaturedStoriesList stories={rest} />
        </div>
      )
    } else {
      const [story] = row

      return (
        <div className={classes.slideRoot} key={key}>
        <FullPageAd story={story} loadContent={loadedSlided[index]} />
        </div>
      )
    }
  })

  const TrackSlideView = (story, activeIndex) => {
    ReactGA.event({
      category: 'View',
      action: 'Slide',
      label: `Title: ${story.title}`,
      value: activeIndex
    })
  }

  const refreshAdOnFeaturedSlide = (slideNumber) => {
    if(slideNumber %2 === 0) {
      dispatch(refreshFullPageAd())
    }
  }

  const handleAfterSlideChange = (newIndex) => {
    const slideStories = stories[newIndex]
    TrackSlideView(slideStories[0], newIndex)
    sessionStorage.setItem('slideIndex', newIndex)
    refreshAdOnFeaturedSlide(newIndex)
    lazyLoadSlides(newIndex)
  }

  const handleSlideNav = (amount) => {
    let newIndex = slideIndex + amount
    newIndex = newIndex >= stories.length ? 0 : newIndex
    newIndex = newIndex < 0 ? stories.length - 1 : newIndex
    setSlideIndex(newIndex)
  }

  const handleScrollUp = () => {
    const slidesNo = slides.length - 1
    setSlideIndex(index => {
      if(isAtTop(index)) return slidesNo // go to bottom slide
      return index - 1
    })
  }

  const handleScrollDown = () => {
    const slidesNo = slides.length - 1
    setSlideIndex(index => {
      if(isAtBottom(index, slidesNo)) return 0 // go to top slide
      return index + 1
    })
  }

  return (
  <>
    <HeaderBar slideChange={handleSlideNav}/>
      <CarouselWrapper
        slides={slides}
        slideIndex={slideIndex}
        slideChange={handleAfterSlideChange}
        upHandler={handleScrollUp}
        downHandler={handleScrollDown} />
  </>
  )
}

export default GameDay
